import React from "react";

interface IIconClearProps {
    width?: string;
    height?: string;
    stroke?: string;
    strokeWidth?: string;
    fill?: string;
    className?: string;
    onClick?: () => void;
}

const IconClear = ({
                       width = '17',
                       height = '17',
                       strokeWidth = '1',
                       fill = '#8E8E93',
                        stroke,
                       className = 'inline vMiddle',
                       onClick
                   }:IIconClearProps) => {
    return (
        <svg
            viewBox="0 0 17 17"
            width={width}
            height={height}
            className={className ? className : null}
            data-name="IconClear"
            onClick={onClick}
        >
            <path
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
                d="M8.5 17C13.1944 17 17 13.1943 17 8.5C17 3.80566 13.1944 0 8.5 0C3.80557 0 0 3.80566 0 8.5C0 13.1943 3.80557 17 8.5 17ZM12.2657 4.73438C12.5781 5.04663 12.5781 5.55322 12.2657 5.86572L9.63138 8.5L12.2657 11.1343C12.5781 11.4468 12.5781 11.9534 12.2657 12.2656C11.9533 12.5781 11.4467 12.5781 11.1343 12.2656L8.5 9.63135L5.86569 12.2656C5.55328 12.5781 5.04675 12.5781 4.73431 12.2656C4.42191 11.9534 4.42191 11.4468 4.73431 11.1343L7.36862 8.5L4.73431 5.86572C4.42191 5.55322 4.42191 5.04663 4.73431 4.73438C5.04672 4.42188 5.55325 4.42188 5.86569 4.73438L8.5 7.36865L11.1343 4.73438C11.4467 4.42188 11.9533 4.42188 12.2657 4.73438Z"
            />
        </svg>
    );
};

export default IconClear;
